

// 帳號類型可使用選單
export const MENU_ACCOUNT_TYPE = [
    {
     'accountType': 'citizen',
     'allowedMenu':  ['用水狀況', '用水指針查詢', '相關連結', '水費試算', '收費期別計量', '用水記事', '體檢卡', '警示設定', '用戶顯示管理設定']
    },
    {
     'accountType': 'group',
     'allowedMenu':  ['用戶清單', '用水狀況', '用水指針查詢', '相關連結', '收費期別計量', '用水記事', '體檢卡', '水費試算', '警示設定', '用戶顯示管理設定', '異常病例統計']
    },
    {
     'accountType': 'group_member',
     'allowedMenu':  ['用戶清單', '用水狀況', '用水指針查詢', '相關連結', '水費試算', '收費期別計量', '用水記事', '體檢卡', '警示設定', '用戶顯示管理設定']
    },
    {
     'accountType': 'unit',
     'allowedMenu':  ['監測圖台', '社區用水', '用水狀況', '用水指針查詢', '收費期別計量']
    },
]

// 水管家可管理之告警規則代號
export const ALARM_RULE_CODE = [ 'r0302', 'r0413', 'r0414', 'r0415', 'r0416', 'r0502', 'r0703', 'r0704', 'r0801', 'r0802']
